<template>
  <div :class="field.width ? `width-${field.width} text field` : 'text field'">
    <h3 v-if="field.section" class="form__section"> {{ field.section }} <span class="form__legend">* Verplicht veld</span></h3>
    <label v-if="field.label"
      :class="field.labelClass ? field.labelClass : 'field__label'"
      :data-active="focus"
      @click="onLabelClick()"
    >
      {{ field.label }}
    </label>
    <span
      v-if="field.subtitle"
      :class="field.subtitleClass ? field.subtitleClass : 'field__subtitle'"
    >
      {{ field.subtitle }}
    </span>
    <FieldValidator ref="validator" :validation="field.validation">
      <div class="field__container">
        <div v-if="field.switchable" class="switch-button">
          <input class="switch-button__button" v-model="checkboxValue" :ref="field.name" type="checkbox" :id="field.name" />
          <label class="switch-button__label" :for="field.name"></label>
        </div>
        <input
          :name="field.name"
          :type="field.type"
          v-model="value"
          ref="field"
          :placeholder="field.placeholder"
          :class="field.class ? field.class : 'text__input'"
          @blur="onBlur()"
          @keydown="onChange(this, field.name)"
          :disabled="field.switchable ? !checkboxValue : false"
        />
      </div>
    </FieldValidator>
  </div>
</template>

<script>
import FieldValidator from "@/components/form/validation/FieldValidator.vue";
import transformers from "@/plugins/Transformers.js";

/**
 * Text input component
 *
 * @category   Components/Input
 * @author     Tim van Lent <tim@growingminds.nl>
 * @copyright  2021 GrowingMinds
 * @since      0.0.1
 */
export default {
  name : 'TextInput',
  components: {
		FieldValidator
  },
  props: {
    prefill: {
      type: String,
      default: "",
    },
    field: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data : function() {
    return {
      value: this.field.value,
      focus: false,
      debounce: null,
      checkboxValue: 0,
      isMask: this.field.mask
    }
  },
  methods: {

    /**
     * on blur
     */
    onBlur: function () {
      this.focus = false;

      // emit change
      this.$emit('blur');

      // on blur validate and send value to tag manager if enabled
      return this.$refs.validator.validate(this.$refs.field, this.value, true);
    },

    onChange : function (fieldName) {

      let val = event.target.value;
      // transform
      if (this.field.transform) for (let modifier of this.field.transform) {
        const transformer = transformers[modifier];
        if (typeof transformer === 'function'){
          const newValue = transformers[modifier](val, event);
          if (this.value !== newValue) {
            this.value = newValue;
            return;
          }
        }
      }

      // validate
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.validate();
        if (this.validate()) {
          console.log(this.value)
          if (this.isMask) {
            var x = this.value.replace(/\D/g, '').match(/(\d{2})(\d{1})(\d{3})(\d{3})(\d{2})/);
            this.value = '(+' + x[1] + ') ' + x[2] + ' ' + x[3] + ' ' + x[4] + ' ' + x[5];
          }
          this.$emit('passValue', this.value, fieldName)
        }
        if (!this.value && !this.validate()) {
          this.$emit('passValue', '', fieldName)
        }
      }, 300)
    },

    /**
     * on label click
     */
    onLabelClick : function () {
      this.focus = true
      this.$refs.field.focus();
    },

    /**
     * Validates the field and returns its valid state
     * @returns bool
     */
    validate: function () {
      return this.$refs.validator.validate(this.$refs.field, this.value);
    },

    /**
     * Get the inputs valid state
     */
    isValid : function () {
      return this.$refs.validator.isValid();
    }
  },
  watch: {
    checkboxValue: function () {
      if (this.checkboxValue) {
        if (this.isMask) {
          this.value = '(+31) '
          window.setTimeout(() => this.$refs.field.focus(), 0);
        }

        if (this.field.validation) {
          this.field.validation.map(val => val.assertion === "noValidation" ? val.assertion = "isEmpty" : '');
        }
        this.$emit('passValue', this.value, this.field.name)
      } else {
        if (this.field.validation) {
          this.field.validation.map(val => val.assertion === "isEmpty" ? val.assertion = "noValidation" : '');
          this.$refs.validator.validate(this.$refs[this.field.name], false);

        }
        this.$emit('passValue', '', this.field.name)
      }
    }
  }
};

</script>
